import { fetchWrapper } from 'app/_helpers/fetch-wrapper';

const WMSInbondURL = process.env.REACT_APP_API_WMSINBOUND_URL;
const baseUrl = `${WMSInbondURL}warehouse`;

export const WarehouseService = {
    getAll,
    getAllWithUserFilter,
    getById,
    create,
    update,
    delete: _delete
};

function getAll() {
    return fetchWrapper.get(baseUrl);
}
function getAllWithUserFilter() {
    return fetchWrapper.get(baseUrl + '/get-all');
}
function getById(id) {
    return fetchWrapper.get(`${baseUrl}/${id}`);
}

function create(params) {
    return fetchWrapper.post(baseUrl, params);
}

function update(id, params) {
    return fetchWrapper.put(`${baseUrl}/${id}`, params);
    //return fetchWrapper.put(`${baseUrl}`, params);
}

// prefixed with underscored because delete is a reserved word in javascript
function _delete(id) {
    return fetchWrapper.delete(`${baseUrl}/${id}`);
}
